import { CareCanvasTemplate } from '../store/types/CareCanvas';
import { CARE_CANVAS_TEMPLATE_BY_ID } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    template?: CareCanvasTemplate;
    error?: string;
}

export default (id: string): Promise<Response> => {
    return fetchWithRefresh(CARE_CANVAS_TEMPLATE_BY_ID(id)).then((res) => res.json());
};
